exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#tyre-type{\n  width: 100%;\n  text-align: center;\n  color: #fff !important;\n  background-color: #63c2de !important;\n  border: none #63c2de !important;\n}\n\n.center{\n  margin: 0 auto;\n  float: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/landingpages/customertyresearch/customertyresearch.component.css
// module id = 1017
// module chunks = 23